export default {
  'memberAreaCouponHistory.title': 'クーポン履歴',
  'memberAreaCouponHistory.time': '時間',
  'memberAreaCouponHistory.serial_number': 'シリアル番号',
  'memberAreaCouponHistory.redeem_store': '利用店舗',
  'memberAreaCouponHistory.redeem_no': '利用番号',
} as Record<string, string>;
